import {Component, Input, OnInit, ElementRef} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {CartService} from '../../services/cart-service';

// Classes
import {Product} from '../../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductsTinyListCmp'));

/**
 * Used to render products list under categories in navigation sidebar
 */
@Component({
    selector: 'products-tiny-list-cmp',
    template: require('./products-tiny-list.cmp.html'),
    styles: [String(require('./products-tiny-list.cmp.scss'))],
    host: { 'class': 'clearfix products-tiny-list'}
})
export class ProductsTinyListCmp {

    @Input() products;

    private _catProdsInCart: Array<Product> = [];
    private _productTinyListElem = true;
    private _subscriptions: any = {};

    
    constructor (
        private _catalogService: CatalogService,
        private _cartService: CartService,
        private _elementRef: ElementRef
    ) {
        // 'Construct products tiny list component' );
    }

    
    ngOnInit() {
        // 'Initialise products tiny list component' );
        this._cacheDomElements();
        this._filterCartProducts();
        this._handleCartUpdate();
    }

    
    ngOnDestroy() {
        // 'Destroy products list component' );

        // Clear subscriptions
        for (let subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    }

    
    private _cacheDomElements () {
        debugOff( 'Cache dom elements' );

        this._productTinyListElem = this._elementRef.nativeElement;
        debugOff( 'Product element:', this._productTinyListElem );
    }

    
    private _handleCartUpdate () {
        debugOff( 'Handle Cart Update' );

        let self = this;

        this._subscriptions.cartUpdated = this._cartService.events.cartUpdated.subscribe( () => {
            self._filterCartProducts();
        });
    }

    /** Improves performance, list does not render unused elements
     */
    private _filterCartProducts () {
        debugOff( 'Filter cart products' );

        // Filter products
        let catProdsInCart = this.products.filter( (product: Product) => {
            return product.isAddedToCart;
        });

        debugOff( 'Category cart products:', catProdsInCart );

        this._catProdsInCart = catProdsInCart;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/products/products-tiny-list.cmp.ts